
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'customizeView',
  inheritAttrs: false,
  props: {
    estimateAmount: {
      type: Number,
      required: false
    },
    promotionAmount: {
      type: Number,
      required: false
    }
  },
  methods: {
    openUrl() {
      window.open('https://nbdeli.feishu.cn/wiki/LxRcwlPEwiOPDCkgsTIc1Vr5n2e', '_blank');
    }
  }
});
